import script from "./UsingKnowledge.vue?vue&type=script&setup=true&lang=js"
export * from "./UsingKnowledge.vue?vue&type=script&setup=true&lang=js"

import "./UsingKnowledge.vue?vue&type=style&index=0&id=328f1128&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328f1128"]])

export default __exports__